<template>
  <van-row>
    <van-list
        :loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <chat-ting-item
          :item="item"
          v-for="item in conversationList"
          :key="item.conversationID"
      />
    </van-list>
  </van-row>
</template>

<script>
import chatTingItem from '@/components/chatTing/Item'
import { mapState } from 'vuex'
export default {
  name: 'chatTingList',
  components: {
    chatTingItem,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
    }
  },
  computed:{
    ...mapState({
      conversationList: state => state.conversation.conversationList,
      currentConversation: state => state.conversation.currentConversation
    })
  },
  methods: {
    onLoad() {
      //this.loading = true
      //this.finished = true
      this.refreshConversation()()
    },
    refreshConversation() {
      let that = this
      return function () {
        if (!that.timeout) {
          that.timeout = setTimeout(() =>{
            that.timeout = null
            that.tim.getConversationList().then(() => {
              that.loading = false
              //that.finished = true
              //that.$toast.success('加载成功')
            })
          }, 1000)
        }
      }
    },
  },
}
</script>

<style scoped>

</style>
